import styled from 'styled-components';

import { cssBreakpoints } from 'theme/theme';

export const CmsTileModalLeftContentHolder = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  overflow: hidden;
  flex-shrink: 0;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    width: 50%;
    height: 100%;
  }
`;

export const CmsTileModalLeftContentImageHolder = styled.div`
  width: 100%;
  height: 100%;
  max-height: calc(100% - 38px);
  overflow: hidden;
`;
